document.addEventListener('DOMContentLoaded', function() {
  const header = document.querySelector('[data-section-id="header"]');
  if (!header) {
    console.error('Header element not found');
    return;
  }

  const hasTopBar = header.classList.contains('has-top-bar');
  
  const hasAnnouncementBar = header.classList.contains('has-announcement-bar');
  if(hasAnnouncementBar) {
    document.body.classList.add('has-announcement-bar');
  }

  if(hasTopBar) {
    document.body.classList.add('has-top-bar');
  }

  handleScroll();
  window.addEventListener("scroll", function() {
    handleScroll();
  });
  function handleScroll() {
    const mobileNav = document.querySelector('#cov-mobile-navigation');
    const header = document.querySelector('[data-section-id="header"]');
    const isTouch = window.matchMedia('(max-width: 991px)').matches;
    const isMobile = window.matchMedia('(max-width: 767px)').matches;
    const hasAnnouncementBar = header.classList.contains('has-announcement-bar');
    const isScroll = document.body.classList.contains('is-scroll');
    const spacing = isScroll ? 0 : (isMobile ? "-32px" : "-40px");
    if(isTouch && !hasAnnouncementBar) {
      mobileNav.style.marginTop = spacing;
    }
  }
})

